import { QuickSessionStepperComponent } from '../../private/gametables/game-table-detail/game-table-sessions/quick-session-stepper/quick-session-stepper.component';
import { Component } from '@angular/core';
import { EventListComponent } from '../../private/events/event-list/event-list.component';

@Component({
  selector: 'app-home',
  imports: [QuickSessionStepperComponent,
    EventListComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {

}






